import axios from "axios";
import { getToken } from "../AuthApi";

export const axiosInstance = axios.create({
  baseURL: "https://apis.trotterit.com/v2/web/",
  headers: {
    "x-access-token": await getToken(),
  },
});
